/**
 * @author PoornaChandu
 */
import React, { useState,useEffect,useRef } from 'react';
import { Button, Drawer, Form, Select, Tooltip, message } from 'antd';
import {
  getDeviceListByFilters,
  getDeviceTypeExclusionList,
  ruleListForDeviceType,
  updateRuleExclusion
} from '../Apicalls.js';
import { DrawerFooter } from '../../Modules/Hierarchy/style.js';
import { EditOutlined } from '@ant-design/icons';
import StyledTable from "../../../commons/styles/table.js";
import { connect } from 'react-redux';
// import { getCurrentTimezone } from '../../../selectors/layout.js';
// import { getTranslationCache } from '../../../selectors/language.js';
// import { createStructuredSelector } from 'reselect';
const { Option } = Select;
const DeviceTypeRuleExclusion = (props) => {
  const [data, setData] = useState([]);
  const [editObj, setEditObj] = useState({});
  const [ruleData, setRuleData] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const hRef = useRef(null);
  useEffect(() => {
    getDatasourceList();
    getRuleList();
  }, []);
  const getRuleList = async () => {
    let ruleData = await ruleListForDeviceType();
    setRuleData(ruleData);
  };
  const getDatasourceList = async () => {
    let data = await getDeviceTypeExclusionList();
    setData(data);
  };
  const translationFunc = (keyword) => {
    let { translationcache } = props;
    return translationcache && translationcache[keyword] ? translationcache[keyword] : keyword;
  };
  const _update = async () => {
    try {
      const values = await hRef.current.validateFields();
      let saveResponse = await updateRuleExclusion(values);
      if (saveResponse && saveResponse.data && saveResponse.data.message) {
        message.success(saveResponse.data.message);
        onClose();
        getDatasourceList();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const onClose = () => {
    setShowDrawer(false);
    setEditObj({});
    if (hRef.current) hRef.current.resetFields();
  };
  const add = () => {
    setShowDrawer(true);
    setEditObj({});
    if (hRef.current) hRef.current.resetFields();
  };
  const onEdit = (editObj) => {
    setEditObj(editObj);
    setShowDrawer(true);
    if (hRef.current) hRef.current.setFieldsValue(editObj);
  };
  const onRuleChange = async (value) => {
    let deviceObject = ruleData.find((rule) => rule.Id === value);
    let deviceList = await getDeviceListByFilters(deviceObject);
    setDeviceList(deviceList);
  };
  const columns = [
    {
      title: 'Rule Name',
      dataIndex: 'Name',
      key: 'Name',
      render: (text) => {
        return {
          children: <div>{text}</div>
        };
      }
    },
    {
      title: translationFunc('Action'),
      dataIndex: 'Action',
      key: 'Action',
      render: (text, row) => {
        return {
          children: (
            <div>
              <Tooltip title={translationFunc('Edit')}>
                <Button
                  className="ant-btn"
                  
                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit(row);
                  }}
                >
                  <EditOutlined />
                </Button>
              </Tooltip>
            </div>
          )
        };
      }
    }
  ];
  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0px' }}>
        <Button type="primary" onClick={add}>
          Add
        </Button>
      </div>
      <Drawer
        title={!editObj.Id ? translationFunc('Create') : translationFunc('Update')}
        open={showDrawer}
        width={600}
        onClose={onClose}
      >
        <Form
          layout="vertical"
          name={'DeviceTypeRules'}
          ref={hRef}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          initialValues={editObj || {}}
        >
          <Form.Item label={'Select Rule'} name="Id" rules={[{ required: true }]}>
            <Select placeholder={translationFunc('Select Rule')} onChange={onRuleChange}>
              {ruleData &&
                Array.isArray(ruleData) &&
                ruleData.map((rule, index) => (
                  <Option key={index} value={rule.Id}>
                    {rule.DisplayRuleName}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={'Select exclusion device'}
            name="Exclude"
            rules={[{ required: true }]}
          >
            <Select mode="tags" placeholder={translationFunc('Select Devices')}>
              {deviceList &&
                Array.isArray(deviceList) &&
                deviceList.map((rule, index) => (
                  <Option key={index} value={rule.AliasCode}>
                    {rule.Name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Form>
        <DrawerFooter>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            {translationFunc('Cancel')}
          </Button>
          <Button type="primary" onClick={_update} style={{marginRight:20}}>
            {!editObj.Id ? translationFunc('Create') : translationFunc('Update')}
          </Button>
        </DrawerFooter>
      </Drawer>
        <StyledTable size="small" columns={columns} dataSource={data} />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    translationCache: state.TranslationReducer.translationCache
  };
};
export default connect(mapStateToProps)(DeviceTypeRuleExclusion);
